<template>
    <v-menu
        v-model="menuOpen"
        offset-y
        min-width="280"
        nudge-top="4"
        :close-on-content-click="false"
    >
        <template v-slot:activator="{ on }">
            <slot name="activator" :on="on">
                <v-text-field
                    :value="value | format_date"
                    :error-messages="errorMessages"
                    :hide-details="!errorMessages"
                    :disabled="disabled"
                    :label="computedLabel"
                    readonly
                    :outlined="!hideLabelBlock"
                    :solo="hideLabelBlock"
                    :dense="hideLabelBlock"
                    class="pb-0"
                    append-icon="mdi-calendar"
                    v-on="on"
                    @click.stop=""
                >
                    <template v-if="clearable" v-slot:append>
                        <v-icon
                            size="24"
                            :color="focused ? 'primary' : 'g4'"
                            v-on="on"
                            @click="$emit('input', null)"
                        >
                            {{ value ? 'close' : 'mdi-calendar' }}
                        </v-icon>
                    </template>
                </v-text-field>
            </slot>
        </template>
        <v-card class="date-range pb-3">
            <v-date-picker
                ref="picker"
                :value="value"
                :max="max"
                :min="min"
                :active-picker="defaultYear ? 'YEAR' : null"
                :locale="formatting.culture"
                :first-day-of-week="formatting.first_week_day"
                no-title
                scrollable
                hide-details
                class="elevation-0"
                @input="onInput($event)"
                @focusin="focused = true"
                @focusout="focused = false"
            />
        </v-card>
    </v-menu>
</template>

<script>
import AppModule from "@/store/modules/app";
import {computed, ref, watch} from "@vue/composition-api";

export default {
    name: "DatePicker",
    props: {
        value: {
            type: String,
            default: null
        },
        errorMessages: {
            type: [String, Array],
            default: null
        },
        label: {
            type: String,
            default: null
        },
        hideLabelBlock: {
            type: Boolean,
            default: false,
        },
        max: {
            type: String,
            default: null
        },
        min: {
            type: String,
            default: null
        },
        clearable: {
            type: Boolean,
            default: false
        },
        defaultYear: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        required: {
            type: Boolean,
            default: false
        }
    },
    setup(props, ctx) {
        const { formatting } = AppModule();
        const menuOpen = ref(false);
        const picker = ref(null);

        const focused = ref(false);

        const onInput = (e) => {
            menuOpen.value = false
            ctx.emit('input', e)
        }

        watch(menuOpen, val => {
            if (props.defaultYear) {
                val && setTimeout(() => (picker.value.activePicker = "YEAR"));
            }
        });

        const computedLabel = computed(() => {
            let label = props.label

            if (props.required) {
                label += ' *';
            }

            return label
        })

        return {
            formatting,
            focused,
            menuOpen,
            onInput,
            picker,
            computedLabel
        }
    }
}
</script>

<style scoped>

</style>